<template>
  <div>
    <div class="empty-container" v-if="value.length === 0">
      <div @click="handleToggleCollapse">Expand to add choices for this question</div>
    </div>
    <draggable
      class="choice-container"
      group="choices"
      draggable=".draggable"
      v-model="computedValue"
      @click.native="handleToggleCollapse"
    >
      <div
        v-for="choice in computedValue"
        class="choice"
        :class="{ draggable: isEditable }"
        :key="choice.id"
        @click.stop
      >{{ choice.title }}</div>
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable';

import Empty from '@/components/common/Empty';

import { parseChoices } from '../../utils';

export default {
  name: 'SelectEditorCollapsed',
  components: {
    draggable,
    Empty,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(values) {
        const choices = parseChoices(values);
        this.$emit('input', choices);
      },
    },
  },
  methods: {
    handleToggleCollapse() {
      this.$emit('onToggleCollapse');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../assets/style/_variables_live.scss';

.choice-container {
  line-height: 2;
  cursor: pointer;
}

.choice {
  padding: 1px 4px;
  border-radius: 6px;
  font-size: 0.8em;
  margin: 2px 4px;
  background-color: $colony-light-gray;
  border: 1px solid darken($colony-light-gray, 15%);
  cursor: default;
  white-space: nowrap;
  display: inline-block;
}

.choice.draggable {
  cursor: grab;
}

.empty-container {
  cursor: pointer;
  margin: 5px 0;
  text-align: center;
  font-size: 0.8em;
  color: #ccc;
  text-shadow: 2px 2px 2px #efefef;
}
</style>



// WEBPACK FOOTER //
// SelectEditorCollapsed.vue?70389f14